import * as React from 'react';
import { cn } from '@/utils/styles';
import { cva, type VariantProps } from 'class-variance-authority';

const inputVariants = cva(
  'relative px-5 h-12 gap-1 items-center flex flex-nowrap content-center overflow-hidden flex-row w-full rounded-lg typography-btn-large transition-colors data-[disabled="true"]:opacity-70 data-[disabled="true"]:cursor-not-allowed focus-within:ring-1 focus-within:ring-stroke-primary-bold data-[invalid="true"]:border data-[invalid="true"]:border-error data-[invalid="true"]:focus-within:ring-error',
  {
    variants: {
      variant: {
        default: 'bg-overlay-primary',
        secondary: 'bg-background border border-stroke-primary-subtle',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> &
  VariantProps<typeof inputVariants>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ disabled, className, type, children, variant, ...props }, ref) => {
    const { 'data-invalid': dataInvalid, ...restProps } = props as any;

    return (
      <div
        data-disabled={disabled}
        data-invalid={dataInvalid}
        className={cn(inputVariants({ variant }), className)}
      >
        <input
          ref={ref}
          type={type}
          disabled={disabled}
          className="data-[invalid=true]:text-error h-full w-full disabled:cursor-not-allowed bg-transparent transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none"
          {...restProps}
        />

        {children}
      </div>
    );
  },
);
Input.displayName = 'Input';

export { Input };
